import React, { useState, useEffect } from "react";
import { SettingProps } from "./Settings";
import AsyncLocalStorage from "../../util/AsyncLocalStorage";
import UserController from "../../controller/UserController";
import { useNavigate } from "react-router-dom";

const TestCarUuid = "123가1234";

const UserList = ({ step, setStep }: SettingProps) => {
  const [loginAccount, setLoginAccount] = useState<any>([]);
  const navigate = useNavigate();
  /*
  const [loginAccount, setLoginAccount] = useState<any>([
    {
      id: 0,
      name: "김스루",
      phone_number: "010-1234-1234",
    },
    {
      id: 1,
      name: "박스루",
      phone_number: "010-4321-4321",
    },
  ]);
  */

  const getUserList = async () => {
    //let oUserData = await AsyncLocalStorage.getItem("accountSetting");
    //if (oUserData) {
    let oRes = await UserController.checkLoggedInWithQr({
      car_uuid: TestCarUuid,
    });
    let oResData = oRes.data;
    if (oRes && oRes.status && oResData && oResData.success) {
      setLoginAccount(oResData.user_list);
    }
    //}
  };

  const addUser = async () => {
    /*
    let oUserData = await AsyncLocalStorage.getItem("accountSetting");
    if (oUserData) {
      navigate("/login/" + oUserData.car_uuid);
    }
    */
    setStep!(3);
  };

  const doLogin = async (oUserData: any) => {
    let oAccountData: any = oUserData;
    AsyncLocalStorage.setItem("accountSetting", JSON.stringify(oAccountData));
    await AsyncLocalStorage.setItem("userToken", oAccountData.token.toString());
    await AsyncLocalStorage.setItem(
      "userRefreshToken",
      oAccountData.refresh_token.toString()
    );
    navigate("/home", { replace: true });
  };

  useEffect(() => {
    getUserList();
  }, []);

  return (
    <div className="wrapper">
      <h1 className="logo">차량 공유</h1>
      <div className="listWrap">
        {loginAccount &&
          loginAccount.length > 0 &&
          loginAccount.map((item: any, index: number) => {
            let sPhoneNumber = item.phone_number;
            try {
              sPhoneNumber = sPhoneNumber
                .trim()
                .replace(/[^0-9]/g, "")
                .replace(
                  /(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,
                  "$1-$2-$3"
                )
                .replace("--", "-");
            } catch (error) {}
            return (
              <div className="buttonBorder" key={index}>
                <button
                  onClick={() => {
                    if (item.use_password === 1) {
                      navigate("/payment/password", {
                        state: {
                          passwordType: "login",
                          loginAccount: JSON.stringify(item),
                        },
                      });
                    } else {
                      doLogin(item);
                    }
                  }}
                >
                  <h1>{sPhoneNumber}</h1>
                  <h1>{item.full_name}</h1>
                </button>
              </div>
            );
          })}
        <div className="buttonBorder">
          <button onClick={addUser}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="plus" />
            <h1>사용자 추가</h1>
          </button>
        </div>
      </div>
    </div>
  );
};
export default UserList;
